import { Component, NgModule, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { UserPanelModule } from '../../user-panel/user-panel.component';
import { ApiService } from '../../../services/api.service';
import { DxButtonGroupModule, DxCheckBoxModule, DxDateBoxModule, DxFormComponent, DxFormModule, DxPopupModule, DxScrollViewModule, DxTextAreaModule, DxValidatorModule } from 'devextreme-angular';
import { BrowserModule } from '@angular/platform-browser';
import { AuthService } from '../../../services';
import notify from 'devextreme/ui/notify';
import { IObavijest, Obavijest } from 'src/app/shared/models/obavijesti.model';
import * as moment from 'moment';

@Component({
  selector: 'add-obavijest-form',
  templateUrl: 'add-obavijest-form.component.html',
  styleUrls: ['./add-obavijest-form.component.scss']
})

export class AddObavijestFormComponent implements OnInit {
  @ViewChild("addObavijestForm", { static: false }) addObavijestForm: DxFormComponent

  @Input()
  isPopupVisible: boolean = false;
  @Input()
  partnerId!: number;
  
  @Output() openModalChange = new EventEmitter<boolean>();
  @Output() obavijestCreated = new EventEmitter<boolean>();
  
  obavijest: IObavijest;

  constructor(
    private _api: ApiService,
    private _authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.initObavijestValues();
  }

  initObavijestValues(){
    this.obavijest = new Obavijest();
  }

  refresh() {
    this.addObavijestForm.instance.resetValues();
  }

  onShown(e){
    this.addObavijestForm.instance.getEditor("ob_datum").focus();
  }

  closePopup(): void {
    this.refresh();
    this.initObavijestValues();
    this.openModalChange.emit(false);
  }

  openPopup(): void {
    this.openModalChange.emit(true);
  }

  form_fieldDataChanged (e) {
    let updatedField = e.dataField;
    let newValue = e.value;

    if(updatedField === "ob_aktivna"){
      this.obavijest.ob_aktivna = newValue ? 1 : 0;
    }
  }

  formatDate(dateValue){
    const selectedDate = new Date(dateValue);
    const newDateFormated = moment(selectedDate).format('YYYY-MM-DD HH:mm:ss').toString();
    return newDateFormated;
  }


  onFormSubmit(e: any){
    e.preventDefault();
    this.submitForm();
  }

  submitForm(){
    this.dodajObavijest();
  }

  dodajObavijest(){
    this._api.dodajObavijest({
      'datum': this.formatDate(this.obavijest.ob_datum),
      'tekst': this.obavijest.ob_tekst,
      'web': this.obavijest.ob_web,
      'aktivna': this.obavijest.ob_aktivna,
      'idkorisnik': this._authService.getUserId(),
      'idpartner': this._authService.getUserPartnerId(),
      'access_token': this._authService.getToken(),
    }).subscribe(res=>{
      // console.log(res)
      if(res.success == true){
        notify("Uspješno ste dodali obavijest!", "success", 1000);
        this.closePopup();
        this.obavijestCreated.emit(true);
      } else {
        notify("Greška prilikom dodavanja obavijesti!", "error", 1000);
      }
    });
  }

}

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    DxButtonModule,
    UserPanelModule,
    DxToolbarModule,
    DxPopupModule,
    DxFormModule,
    DxScrollViewModule,
    DxButtonGroupModule,
    DxCheckBoxModule,
    DxValidatorModule,
    DxDateBoxModule,
    DxTextAreaModule,
    DxCheckBoxModule
  ],
  declarations: [ AddObavijestFormComponent ],
  exports: [ AddObavijestFormComponent ]
})
export class AddObavijestFormComponentModule { }
